var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"play-button-isolated",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('polygon',{attrs:{"points":"40,30 65,50 40,70"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }